module.exports = __webpack_public_path__ + "static/media/obw-teachnologies.a132f102.png";